import gql from "graphql-tag"
import PUBLISHER_FRAGMENT from "../../publisher/graphql/publisher-fragment"

export default gql`
  query ResourcePublisher($id: Int) {
    resource(id: $id) {
      id
      publisher {
        ...Publisher
      }
    }
  }
  ${PUBLISHER_FRAGMENT}
`
